import { Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { normalizeStepTitle } from './model/helpers';
import SolarIcon from 'components/icons/SolarIcon';

type QuickStartStepProps = {
    step: number;
    title: string;
    text: string;
};

const QuickStartStep = ({ step, title, text }: QuickStartStepProps) => (
    <div className="col-12 col-md-4">
        <div className="border rounded p-3 bg-light bg-opacity-25 h-100">
            <div className="d-flex align-items-start gap-3">
                <span
                    className="d-inline-flex align-items-center justify-content-center rounded-circle border border-primary text-primary fw-semibold flex-shrink-0"
                    style={{ width: 30, height: 30, fontSize: 13, lineHeight: 1 }}
                >
                    {step}
                </span>
                <div>
                    <div className="fw-semibold">{normalizeStepTitle(title)}</div>
                    <small className="text-muted d-block mt-1">{text}</small>
                </div>
            </div>
        </div>
    </div>
);

const TelegramBotQuickStart = () => {
    const { t } = useTranslation(['Settings']);

    const steps = [
        { step: 1, title: t('telegramBot.steps.step1.title'), text: t('telegramBot.steps.step1.text') },
        { step: 2, title: t('telegramBot.steps.step2.title'), text: t('telegramBot.steps.step2.text') },
        { step: 3, title: t('telegramBot.steps.step3.title'), text: t('telegramBot.steps.step3.text') },
    ];

    return (
        <Card className="mb-3">
            <Card.Body>
                <div className="d-flex align-items-center gap-2 mb-3">
                    <SolarIcon name="telegram" className="text-primary fs-5" />
                    <h6 className="mb-0">{t('telegramBot.quickStartTitle')}</h6>
                </div>

                <div className="row g-2">
                    {steps.map(({ step, title, text }) => (
                        <QuickStartStep key={step} step={step} title={title} text={text} />
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

export default TelegramBotQuickStart;
